import Select from './Select';
import SelectNode from './SelectNode';

export { SHOW_ALL, SHOW_CHILD, SHOW_PARENT } from './strategies';
export var TreeNode = SelectNode;

export default Select;


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/node_modules/rc-tree-select/es/index.js
// module id = null
// module chunks = 